import request from '@/utils/request';

function apiGetDistinctShipmentDates() {
  return request({
    method: 'get',
    url: 'storeOrderLine/GetDistinctShipmentDates'
  });
}

function apiExportAsPDF(shipmentDate) {
  return request({
    method: 'get',
    url: `storeOrderLine/DownloadShipmentListAsPDF`,
    params: {
      shipmentDate: shipmentDate
    },
    responseType: 'blob'
  });
}

export const storeExtensions = {
  actions: {
    getDistinctShipmentDates({ commit, dispatch }, searchQuery) {
      return new Promise((resolve, reject) =>
        apiGetDistinctShipmentDates(searchQuery)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    },
    exportAsPDF({ commit, dispatch }, { shipmentDate }) {
      return new Promise((resolve, reject) =>
        apiExportAsPDF(shipmentDate)
          .then(response => {
            resolve(response.data);
          })
          .catch(error => {
            reject(error);
          })
      );
    }
  }
};
